"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCacheClient = exports.reconnectStrategy = exports.setIsCacheReady = exports.MAX_RETRIES = void 0;
const polaris_client_utils_1 = require("@noths/polaris-client-utils");
const bunyan_1 = __importDefault(require("bunyan"));
const redis_1 = require("redis");
const constants_1 = require("./constants");
exports.MAX_RETRIES = 5;
const logger = (0, polaris_client_utils_1.isBrowser)()
    ? console
    : bunyan_1.default.createLogger({
        name: process.env.DD_SERVICE_NAME || 'unknown',
    });
let cacheClient = null;
let isCacheReady = false;
const setIsCacheReady = (readyState) => (isCacheReady = readyState);
exports.setIsCacheReady = setIsCacheReady;
const getByKey = (cacheKey, cacheTTLInSeconds = 300) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isCacheReady) {
        return null;
    }
    try {
        const cacheEntry = yield (cacheClient === null || cacheClient === void 0 ? void 0 : cacheClient.get(cacheKey));
        if (!cacheEntry) {
            return null;
        }
        const { data, updated } = JSON.parse(cacheEntry);
        const cacheTTLInMilliseconds = cacheTTLInSeconds * 1000;
        const status = updated + cacheTTLInMilliseconds < Date.now() ? constants_1.CACHE_STATUS_EXPIRED : constants_1.CACHE_STATUS_FRESH;
        return {
            data,
            updated,
            status,
        };
    }
    catch (_a) {
        return null;
    }
});
const setByKey = (cacheKey, data) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isCacheReady) {
        return;
    }
    yield (cacheClient === null || cacheClient === void 0 ? void 0 : cacheClient.set(cacheKey, JSON.stringify({
        data,
        updated: Date.now(),
    })));
});
const reconnectStrategy = (retries) => {
    logger.info(`Trying to reconnect to Redis: Attempt #${retries + 1}`);
    if (retries <= exports.MAX_RETRIES) {
        return retries * 50;
    }
    return constants_1.RECONNECTION_RETRY_TIME;
};
exports.reconnectStrategy = reconnectStrategy;
/* istanbul ignore next */
const createCacheClient = () => {
    if (!(Boolean(process.env.REDIS_HOST) && Boolean(process.env.REDIS_AUTH_TOKEN))) {
        console.error('REDIS_HOST and REDIS_AUTH_TOKEN must be set in the environment in order to use caching');
        return;
    }
    if (cacheClient) {
        return {
            getByKey,
            setByKey,
        };
    }
    cacheClient = (0, redis_1.createClient)({
        socket: {
            host: process.env.REDIS_HOST,
            tls: process.env.REDIS_HOST !== 'localhost',
            reconnectStrategy: exports.reconnectStrategy,
        },
        password: process.env.REDIS_AUTH_TOKEN,
    });
    cacheClient.connect();
    cacheClient.on('error', (error) => {
        logger.warn('Redis client error', error);
    });
    cacheClient.on('connect', () => {
        logger.info('Connecting Redis client');
    });
    cacheClient.on('ready', () => {
        logger.info('Redis client ready');
        (0, exports.setIsCacheReady)(true);
    });
    cacheClient.on('end', () => {
        logger.warn('Redis client disconnected');
        (0, exports.setIsCacheReady)(false);
    });
    cacheClient.on('reconnecting', () => {
        logger.info('Reconnecting Redis client');
    });
    return {
        getByKey,
        setByKey,
    };
};
exports.createCacheClient = createCacheClient;
